// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import App from "@/App";
import router from "@/router";
import BootstrapVue from "bootstrap-vue";
import "nprogress/nprogress.css";
import "@/assets/style/custom.scss";
// import "@/assets/style/insurance.scss";

import VueScrollTo from "vue-scrollto";

// import https://fontawesome.com/v4.7.0/icons/
import "vue-awesome/icons/chevron-down";
import "vue-awesome/icons/chevron-right";
import "vue-awesome/icons/arrow-left";
import "vue-awesome/icons/circle";
import "vue-awesome/icons/circle-thin";
import "vue-awesome/icons/circle-o";
import "vue-awesome/icons/times-circle";
import "vue-awesome/icons/times";
import "vue-awesome/icons/close";
import "vue-awesome/icons/check-circle";
import "vue-awesome/icons/twitter";
import "vue-awesome/icons/eye";
import "vue-awesome/icons/plus";
import "vue-awesome/icons/plus-circle";
import "vue-awesome/icons/minus";
import "vue-awesome/icons/minus-circle";
import "vue-awesome/icons/search";
import "vue-awesome/icons/folder-open";
import "vue-awesome/icons/folder";
import "vue-awesome/icons/file";
import "vue-awesome/icons/question-circle";
import "vue-awesome/icons/commenting-o";
import "vue-awesome/icons/check";
import "vue-awesome/icons/check-circle-o";
import "vue-awesome/icons/comments-o";
import "vue-awesome/icons/chevron-up";

import "vue-awesome/icons/share-alt";
import "vue-awesome/icons/eraser";
import "vue-awesome/icons/envelope-open-o";
import "vue-awesome/icons/envelope-o";
import "vue-awesome/icons/mobile";
import "vue-awesome/icons/phone";
import "vue-awesome/icons/volume-control-phone";
import "vue-awesome/icons/file-text-o";

import "vue-awesome/icons/history";
import "vue-awesome/icons/save";
import "vue-awesome/icons/dollar";
import "vue-awesome/icons/gift";
import "vue-awesome/icons/user-o";
import "vue-awesome/icons/sign-out";
import "vue-awesome/icons/ellipsis-v";

import "vue-awesome/icons/at";
import "vue-awesome/icons/television";
import "vue-awesome/icons/ticket";
import "vue-awesome/icons/users";
import "vue-awesome/icons/bank";
import "vue-awesome/icons/home";
import "vue-awesome/icons/car";
import "vue-awesome/icons/location-arrow";
import "vue-awesome/icons/building";
import "vue-awesome/icons/compass";
import "vue-awesome/icons/university";
import "vue-awesome/icons/shopping-bag";
import "vue-awesome/icons/desktop";
import "vue-awesome/icons/adn";
import "vue-awesome/icons/envelope";
import "vue-awesome/icons/magic";
import "vue-awesome/icons/envelope-square";
import "vue-awesome/icons/phone-square";

import "vue-awesome/icons/expand";
import "vue-awesome/icons/compress";
import "vue-awesome/icons/caret-right";
import "vue-awesome/icons/pencil";
import "vue-awesome/icons/bar-chart";
import "vue-awesome/icons/pie-chart";

import Icon from "vue-awesome/components/Icon";

import store from "@/store";

import "@/http";

import * as filters from "@/assets/filters";
import * as directives from "@/assets/directives";

import MLoader from "@/components/common/MLoader";
import notification from "@/components/common/notification";
import MBox from "@/components/common/MBox";
import MDialog from "@/components/common/MDialog";

import utlis from "@/assets/utils/index";

// init bootstrap vue
Vue.use(BootstrapVue);
Vue.config.productionTip = false;

Vue.use(VueScrollTo);

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
// register global utility directives.
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
});

Vue.component("icon", Icon);
Vue.component("MLoader", MLoader);
Vue.component("MBox", MBox);
Vue.component("MDialog", MDialog);

Vue.prototype.$notice = function(msg, type, options) {
  notification.notice(msg, type, options);
};

// global error
const errorHandler = (error, vm, info) => {
  console.error(error);
  utlis.log("js", info, error.name + ": " + error.message, error.stack);
};
Vue.config.errorHandler = errorHandler;

if (
  window.first.env === "local" ||
  window.first.env === "dev" ||
  window.first.env === "prod"
) {
  window.store = store;
}

let app = new Vue({
  store,
  router,
  template: "<App/>",
  components: {
    App,
    Icon
  }
});

let main = {
  checkLogin() {
    if (window.first.isLogin === "ok" || window.first.isLogin === "false") {
      if (window.first.isLogin === "ok") {
        window.intercomSettings = {
          app_id: "onky7rvz"
          // name: window.first.fullName,
          // email: window.first.email,
          //created_at: window.first.createDate.replace('/Date(', '').replace(')/', '').substring(0, 10)
        };
      } else {
        window.intercomSettings = {
          app_id: "onky7rvz"
        };
      }
      app.$mount("#app");
    } else if (window.first.isLogin === "hold") {
      window.intercomSettings = {
        app_id: "onky7rvz"
      };
      setTimeout(main.checkLogin, 10);
    }
  },
  // loadCss() {
  //   Vue.http
  //     .post("PlaceOrder.aspx/GetAnonymousCss", {
  //       userId: 0
  //     })
  //     .then(resp => {
  //       if (resp.body.d.DataSource !== null&&resp.body.d.DataSource !=='') {
  //         //utlis.loadCss(resp.body.d.DataSource)
  //       }
  //     });
  // }
};
main.checkLogin();
//main.loadCss();
export default app;



// WEBPACK FOOTER //
// ./src/main.js